import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getSession } from "../session"; // <-- путь на уровень выше

const ProtectedRoute = () => {
    const loc = useLocation();
    const session = getSession();
    if (!session) {
        return <Navigate to="/admin/login" replace state={{ from: loc }} />;
    }
    return <Outlet />;
};

export default ProtectedRoute;
